/* eslint-disable react-hooks/exhaustive-deps */

import { instance2, TYPE_INSTANCE2 } from "App/constants";
import {
  IconButtonDatatable,
  InputOptionMaster,
  InputTextMaster,
  Loading,
  MasterButton,
  Modal,
} from "App/Component/ui";
import { Grid } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { defaultToastError, defaultToastSuccess } from "App/utils/helpers";
import {
  urlAddMovieList,
  urlDeleteListMovie,
  urlGetListMovie,
  urlGetListMovieByDisplay,
} from "./helpers";
import { useSelectOption } from "App/hooks";
import { AddIcon, TrashIcon } from "App/Assets";
import { deleteMovieListById } from "../MovieList/helpers";

const ModalDetailMovieProfiling = ({ setShowModal, name, id }) => {
  const movieList = useSelectOption(true, urlGetListMovie, TYPE_INSTANCE2);
  const [movieListId, setMovieListId] = useState({
    value: null,
    label: "Pilih Video",
  });
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleClickAdd = async (e) => {
    setLoading(true);
    if (movieListId.value === null) {
      setLoading(false);
      defaultToastError("Pilih Movie Terlebih dahulu");
    } else {
      try {
        await instance2.post(urlAddMovieList, {
          moviedisplay_id: id,
          movie_id: movieListId.value,
          remark: "-",
        });
        defaultToastSuccess("Berhasil menambah list movie");
        setMovieListId({
          label: null,
          value: "",
        });
        setNewData();
        setLoading(false);
      } catch (error) {
        defaultToastError(error?.response?.data?.message);
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    setNewData();
  }, []);

  async function setNewData() {
    setLoading(true);
    try {
      const res = await instance2.get(urlGetListMovieByDisplay, {
        headers: {
          moviedisplay_id: id,
        },
      });
      setRows(res.data.body);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setRows([]);
    }
  }

  return (
    <Modal title={`PROFILE PLAYLIST`} show={setShowModal} width='50%'>
      <Grid container spacing={1}>
        <Grid item sm={12}>
          <InputTextMaster
            name='name'
            label='Nama'
            id='name'
            value={name}
            readOnly={true}
            disabled={true}
            placeholder='Nama'
          />
        </Grid>
      </Grid>

      <div className='mt-2 mb-2'>
        <p className='fw-600 fs-16'> DAFTAR MOVIE UNTUK PROFILE INI</p>

        <div className='mt-1'>
          <Grid container spacing={2} alignItems='center'>
            <Grid item sm={11}>
              <InputOptionMaster
                name='movie_id'
                label='PILIH NAMA MOVIE'
                id='movie_id'
                withSearch={true}
                data={movieList}
                value={movieListId.value}
                labelValue={movieListId.label}
                onChange={(e) =>
                  setMovieListId({
                    label: e?.label,
                    value: e?.value,
                  })
                }
              />
            </Grid>
            <Grid item sm={1}>
              <IconButtonDatatable
                onClick={handleClickAdd}
                style={{
                  marginTop: "1rem",
                  borderRadius: "4px",
                  backgroundColor: "green"
                }}>
                <AddIcon
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "auto",
                    textAlign: "center",
                  }}
                />
              </IconButtonDatatable>
            </Grid>
          </Grid>
        </div>
      </div>

      <ListMovie
        rows={rows}
        setNewData={setNewData}
        loading={loading}
        setLoading={setLoading}
      />

      <Grid
        container
        direction='row'
        justifyContent='flex-end'
        alignItems='center'>
        <MasterButton
          className={"mt-2"}
          type='button'
          color='danger'
          name='TUTUP'
          onClick={() => setShowModal(false)}
          size='md'
        />
      </Grid>
    </Modal>
  );
};

const ListMovie = ({ rows, setNewData, loading, setLoading }) => {
  const handleClickDelete = async (id) => {
    setLoading(true);
    const res = await deleteMovieListById(id);
    if(res.state) {
      defaultToastSuccess(res.message);
      setNewData();
      setLoading(false);
    } else {
      defaultToastError(res.message);
      setLoading(false);
    }
    // try {
    //   await instance2.post(
    //     urlDeleteListMovie,
    //     {},
    //     {
    //       headers: {
    //         idmovielist: id,
    //       },
    //     }
    //   );
    //   setNewData();
    //   setLoading(false);
    // } catch (error) {
    //   setLoading(false);
    //   defaultToastError(error?.response?.data?.message);
    // }
  };

  return (
    <div>
      <Loading show={loading} />
      {rows?.map((row, index) => {
        return (
          <Grid container spacing={2} alignItems='center' key={index}>
            <Grid item sm={11}>
              <InputTextMaster
                name='movie_id'
                label=''
                id='movie_id'
                value={row?.name}
                readOnly={true}
                disabled={true}
              />
            </Grid>
            <Grid item sm={1}>
              <IconButtonDatatable
                onClick={() => handleClickDelete(row?.id)}
                style={{
                  borderRadius: "4px",
                  backgroundColor: "red"
                }}>
                <TrashIcon
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "auto",
                    textAlign: "center",
                  }}
                />
              </IconButtonDatatable>
            </Grid>
          </Grid>
        );
      })}
    </div>
  );
};

React.memo(ListMovie);

export default React.memo(ModalDetailMovieProfiling);
